import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ScrollReveal from "./ScrollReveal";

const TryUsOut = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 bg-primary overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
        
        {/* Text Section - Removed ScrollReveal to fix LCP delay */}
        <div className="flex-1 text-center lg:text-left">
          <h2 className="text-4xl md:text-5xl lg:text-4xl xl:text-5xl font-bold text-background leading-tight lg:whitespace-nowrap">
            Try Us Out! Get Your First Transaction Free!
          </h2>
        </div>
        
        {/* Button Section - Keep animation for secondary elements */}
        <div className="flex-shrink-0 w-full lg:w-auto mt-4 lg:mt-0">
          <ScrollReveal delay={0.1}>
            <Button 
              size="lg" 
              className="w-full lg:w-auto bg-white text-slate-900 hover:bg-slate-100 hover:text-slate-900 text-lg px-8 py-6 h-auto shadow-lg hover:scale-105 transition-all font-semibold"
              onClick={() => {
                navigate('/get-started');
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Get Started
            </Button>
          </ScrollReveal>
        </div>

      </div>
    </section>
  );
};

export default TryUsOut;